export interface GetCallLogsDetailsInput {
  readonly logicalDeviceId: string;
  readonly callId: string;
}
